import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import { AuthenticationService } from './authentication.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../app.config";
import * as i3 from "./authentication.service";
var CheckProfileService = /** @class */ (function () {
    function CheckProfileService(http, config, authenticationService) {
        this.http = http;
        this.config = config;
        this.authenticationService = authenticationService;
        this.messages = [];
        this.checkProfileData = new Subject();
    }
    CheckProfileService.prototype.checkprofile = function () {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/users/checkprofile");
    };
    CheckProfileService.prototype.setWarningCheckProfile = function (warning) {
        this.warningCheckProfile = warning;
        this.checkProfileData.next({
            warningCheckProfile: this.warningCheckProfile,
            messages: this.messages
        });
    };
    CheckProfileService.prototype.getWarningCheckProfile = function () {
        return this.warningCheckProfile;
    };
    CheckProfileService.prototype.getMessages = function () {
        var _this = this;
        var currentUser;
        this.authenticationService.currentUser.subscribe(function (x) { return currentUser = x; });
        if (currentUser && currentUser.profilo === 'P') {
            this.checkprofile().subscribe(function (data) {
                _this.messages = data.result;
                if (_this.messages.length > 0) {
                    _this.warningCheckProfile = true;
                }
                else {
                    _this.warningCheckProfile = false;
                }
                _this.checkProfileData.next({
                    warningCheckProfile: _this.warningCheckProfile,
                    messages: _this.messages
                });
            }, function (error) {
                _this.warningCheckProfile = false;
                _this.checkProfileData.next({
                    warningCheckProfile: _this.warningCheckProfile,
                    messages: _this.messages
                });
            });
        }
    };
    CheckProfileService.ngInjectableDef = i0.defineInjectable({ factory: function CheckProfileService_Factory() { return new CheckProfileService(i0.inject(i1.HttpClient), i0.inject(i2.AppConfig), i0.inject(i3.AuthenticationService)); }, token: CheckProfileService, providedIn: "root" });
    return CheckProfileService;
}());
export { CheckProfileService };
